<template>
    <div>
        
    </div>
</template>

<script setup>
import { onMounted, onUnmounted } from "vue";
import {
    useRouter,
} from 'vue-router'
import {
    setEntry
} from "@/utils/author.js";

let router = useRouter()
setEntry({
    type: 'thirdPart'
})

onMounted(() => {
    const { client_id, ip, client_secret } = router.currentRoute.value?.query
    setEntry({
        type: 'thirdPart',
        query: { client_id, ip, client_secret }
    })
    // http://localhost:8088/preview?ip=10.90.11.74&client_id=jsnykey&client_secret=jsnysecret
    //console.log(client_id, ip);
    window.location.replace(`http://${ip}/cas/oauth2.0/authorize?response_type=code&client_id=${client_id}&redirect_uri=http://${window.location.host}/thirdPart`)
});
onUnmounted(() => { })
</script>

<style scoped></style>